




































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component
export default class ReportShare extends Vue {
    @Prop({ required: true }) trigger!: boolean
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop({ required: false }) dataToConfirm: any

    @Watch('trigger')
    ondialogPropChange () {
        this.getUsersFilter()
        this.getReportShares()
        if (this.dataToConfirm) {
            this.dialog = true
        }
        this.loading = false
    }

    @Watch('dataToConfirm')
    onDataToConfirmChange () {
        this.users = []
        // this.dialog = false
    }

    dialog = false
    loading = false

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    users: any[] = []
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    usersList: any[] = []

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    checkUserSeleted (data: any) {
        return data.attrs['aria-selected'] === 'true' ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
    }

    likesSome () {
        return this.users.length > 0 && !this.likesAll()
    }

    icon () {
        if (this.likesAll()) return 'mdi-close-box'
        if (this.likesSome()) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
    }

    likesAll () {
        return this.users.length === this.usersList.filter(x => x.userId).length
    }

    getUsersFilter () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getUsersFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        const userFormat = Object.assign([], resp.data)
                        const userLogued = this.$store.state.AuthStore.auth.user.userId
                        this.usersList.push({ header: 'Others' })
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        userFormat.forEach((element: any) => {
                            if (element.userId !== userLogued) {
                                if (element.providerId?.providerName && !this.usersList.find(x => x.header === element.providerId?.providerName)) {
                                    this.usersList.push({ divider: true })
                                    this.usersList.push({ header: element.providerId?.providerName })
                                }
                                this.usersList.push(element)
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getReportShares () {
        if (this.dataToConfirm) {
            return new Promise<void>(resolve => {
                this.$store.dispatch('getReportShares', this.dataToConfirm.reportId)
                    .then(resp => {
                        if (resp.status === 200) {
                            this.users = []
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            resp.data.map((item: any) => {
                                this.users.push(item.userId)
                            })
                            resolve()
                        }
                    })
            })
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getReportName (report: any) {
        if (report && report.reportName) {
            return report.reportName
        } else {
            return ''
        }
    }

    toggle () {
        this.$nextTick(() => {
            if (this.likesAll()) {
                this.users = []
            } else {
                this.users = this.usersList.filter(x => x.userId)
            }
        })
    }

    remove (userId: number) {
        const index = this.users.indexOf(userId)
        if (index >= 0) this.users.splice(index, 1)
    }

    confirmedDialogShare () {
        this.loading = true
        this.$store.dispatch('createReportShares', { reportId: this.dataToConfirm.reportId, users: this.users })
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.hideModal()
                }
            })
    }

    hideModal () {
        this.dialog = false
        this.loading = false
    }
}
